export default defineNuxtPlugin(() => {
  const autenticacaoStore = useAutenticacaoStore()

  // Só inicializa se o usuário estiver logado
  if (autenticacaoStore.token) {
    // Inicializa o sistema de logout automático
    // O composable já monitora automaticamente a inatividade
    useIdleLogout()
  }
})
